import { Directive } from '@angular/core';
import { ItemComponentBase } from '../ItemComponentBase';

@Directive()
export abstract class CommonItemComponentBase extends ItemComponentBase {}
